import React from 'react';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { Services } from './components/Services';
import { Reviews } from './components/Reviews';
import { About } from './components/About';
import { Contact } from './components/Contact';
import { Map } from './components/Map';
import { Footer } from './components/Footer';
import { WhatsAppButton } from './components/WhatsAppButton';
import { PrivacyPolicy } from './components/PrivacyPolicy';
export function App() {
  return <div className="min-h-screen bg-mimate-bg font-body text-mimate-text selection:bg-mimate-primary/30" data-id="element-0">
      <Header data-id="element-1" />

      <main data-id="element-2">
        <Hero data-id="element-3" />
        <Services data-id="element-4" />
        <About data-id="element-5" />
        <Reviews data-id="element-6" />
        <Contact data-id="element-7" />
        <Map data-id="element-8" />
      </main>

      <Footer data-id="element-9" />

      <WhatsAppButton data-id="element-10" />
      <PrivacyPolicy data-id="element-11" />
    </div>;
}